module.exports = __webpack_public_path__ + "static/media/physical-health.e27d2970.jpg";